import { utilities } from '@weatherbug/common';
const { isString, isNumber } = utilities;

export const isValidDisplayValue = (value) => isNumber(value) || isString(value);
